import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { when } from 'mobx';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { ApplicationStore } from '../data_layer/stores/ApplicationStore';
import { Dashboard } from './pages/Dashboard';
import { History } from './pages/History';
import { FullSummary } from './pages/FullSummary';
import { TopNavBar } from './components/TopNavBar';
import { pageContainerStyle } from '../assets/styles/Layout/PageContainer';
import { ContactUs } from './pages/ContactUs';

interface Props extends RouteComponentProps<{}> {
    store: ApplicationStore;
}

@inject('store')
@observer
export class NavigationController extends React.Component<Props> {
    public constructor(props: Props) {
        super(props);
        when(() => {
                const autoAuthComplete = this.props.store.authorizationStore.autoLogOnComplete;
                const notLoggedIn = false === this.props.store.authorizationStore.isAuthenticated;
                return autoAuthComplete && notLoggedIn;
            },
            () => {
                this.routeToLogIn();
            }
        );
    }

    private routeToLogIn() {
        this.props.history.push('/login');
    }

    public render() {
        if (this.props.store && this.props.store.storeIsReady) {
            return (
                <div style={{ display: 'flex' }}>
                    <div style={pageContainerStyle}>
                        <TopNavBar {...this.props} />
                        <Switch>
                            <Route exact={true} path="/dashboard" component={Dashboard}/>
                            <Route exact={true} path="/history" component={History}/>
                            <Route exact={true} path="/history/:id" component={Dashboard}/>
                            <Route exact={true} path="/contact" component={ContactUs}/>
                            <Route path="/full-summary/:category" component={FullSummary}/>
                            <Route exact={true} path="/history/:id/full-summary/:category" component={FullSummary}/>
                            <Redirect exact={true} path="/" to={"/dashboard"}/>
                        </Switch>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/NavigationController.tsx